"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageTagViews = exports.BottomViews = exports.InfoViews = exports.ImageViews = void 0;
var React = require("react");
var RemindMeBtn_1 = require("../RemindMeBtn");
var styles = require("./index.scss");
var admin_1 = require("services/page/admin");
var MobileImageViews_1 = require("components/newUI/Common/ImageViews/MobileImageViews");
exports.ImageViews = function (columnNum, img) {
    if (columnNum === 1) {
        return (React.createElement(MobileImageViews_1.MobileImageViews, { isPostImageToBackground: true, src: img, style: {
                maxWidth: "100%",
                maxHeight: "100%"
            }, isLazyLoad: true, params: "imageView2/2/w/200", alisize: 2 }));
    }
    if (columnNum === 2) {
        return (React.createElement(MobileImageViews_1.MobileImageViews, { isPostImageToBackground: true, isLazyLoad: true, src: img, style: {
                maxWidth: "100%",
                maxHeight: "100%",
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px"
            }, params: "imageView2/2/w/300", alisize: 2 }));
    }
    return null;
};
exports.InfoViews = function (props) {
    var columnNum = props.columnNum, isActView = props.isActView, name = props.name, price = props.price, originalPrice = props.originalPrice;
    if (columnNum === 1) {
        return NameViews(name, columnNum);
    }
    if (columnNum === 2) {
        return (React.createElement("div", { className: styles["infoViews_" + columnNum] },
            !isActView && NameViews(name, columnNum),
            !isActView && (React.createElement("p", { className: styles.priceWrap },
                React.createElement("span", { className: styles.price }, price),
                price !== originalPrice && (React.createElement("span", { className: styles.originalPrice }, originalPrice))))));
    }
    return null;
};
exports.BottomViews = function (props) {
    var columnNum = props.columnNum, multiTab = props.multiTab, state = props.state, stock = props.stock, soldOut = props.soldOut, startTime = props.startTime, isRemindMe = props.isRemindMe, price = props.price, originalPrice = props.originalPrice, remindMe = props.remindMe;
    if (columnNum === 1) {
        return (React.createElement("div", { className: styles["bottomViews_" + columnNum] },
            React.createElement("div", { className: styles.bottomViewsBox },
                React.createElement("div", { className: styles.priceWrap },
                    React.createElement("p", { className: styles.price }, price),
                    React.createElement("p", { className: styles.originalPrice }, originalPrice)),
                !soldOut && state === admin_1.TActState.OnGoing && (React.createElement("div", { className: styles.stock },
                    PcsViews(stock, state),
                    BuyNowViews(columnNum, soldOut))),
                state === admin_1.TActState.ComingSoon && (React.createElement("div", { className: styles.remind },
                    !multiTab && ClockViews(startTime, columnNum),
                    React.createElement(RemindMeBtn_1.default, { bWidth: "5.6875rem", bHeight: "2rem", isRemindMe: isRemindMe, remindRightBtn: remindMe })))),
            SoldOutViews(soldOut, columnNum)));
    }
    if (columnNum === 2) {
        return (React.createElement("div", { className: styles["bottomViews_" + columnNum] },
            React.createElement("div", { className: styles.bottomViewsBox },
                (multiTab || state === admin_1.TActState.OnGoing) && PcsViews(stock, state),
                state === admin_1.TActState.OnGoing && BuyNowViews(columnNum, soldOut),
                state === admin_1.TActState.ComingSoon && !multiTab && ClockViews(startTime, columnNum),
                state === admin_1.TActState.ComingSoon && (React.createElement(RemindMeBtn_1.default, { bWidth: "5.625rem", bHeight: "1.75rem", isRemindMe: isRemindMe, remindRightBtn: remindMe })))));
    }
    return null;
};
exports.ImageTagViews = function (isActView, discount, columnNum, soldOut) {
    var discountNum = discount.split("%")[0];
    return (React.createElement("div", { className: styles.imageTagViews },
        !isActView && Number(discountNum) && (React.createElement("div", { className: styles.discountNum },
            discount,
            " OFF")),
        columnNum === 2 && SoldOutViews(soldOut, columnNum)));
};
var SoldOutViews = function (soldOut, columnNum) {
    if (soldOut) {
        var src = columnNum === 1
            ? "https://i.ezbuy.sg/FrFRRPCUE1KfSk8rzRqcYg9M3nAN"
            : "https://i.ezbuy.sg/FqWviBTrOPaWx_d5sZ8wRUIZ7SuJ";
        return (React.createElement("div", { className: styles["soldOut_" + columnNum] },
            React.createElement("img", { src: src })));
    }
    return null;
};
var NameViews = function (name, columnNum) {
    return React.createElement("p", { className: styles["nameViews_" + columnNum] }, name);
};
var PcsViews = function (num, state) {
    var isComing = state === admin_1.TActState.ComingSoon;
    return (React.createElement("div", { className: styles.pcsViews },
        React.createElement("span", { className: styles.num },
            num,
            " "),
        React.createElement("span", { className: styles.text },
            "pcs ",
            !isComing && "left")));
};
var BuyNowViews = function (columnNum, soldOut) {
    return (React.createElement("div", { className: styles["buyNowViews_" + columnNum], style: {
            background: soldOut
                ? "#ccc"
                : "linear-gradient(129deg, rgba(254, 69, 106, 1) 0%, rgba(227, 13, 5, 1) 100%)"
        } }, "Buy Now"));
};
var ClockViews = function (startTime, columnNum) {
    return (React.createElement("div", { className: styles["clockViews_" + columnNum] },
        React.createElement("img", { src: "https://i.ezbuy.sg/Fv_-bugUtQzuHmV-7H4vn7VlCeyG" }),
        React.createElement("span", null, startTime)));
};
